import { Builder3vv3qt9kyowg0 as Builder } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.m6o_1 = (new (Builder())('SecretToken')).i37();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance3i9l0rhq56ftk,
};
//endregion

//# sourceMappingURL=SecretToken.mjs.map
